import { render } from "./AuditGenerate.vue?vue&type=template&id=6b34c3f7"
import script from "./AuditGenerate.vue?vue&type=script&lang=js"
export * from "./AuditGenerate.vue?vue&type=script&lang=js"

import "./AuditGenerate.vue?vue&type=style&index=0&id=6b34c3f7&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__